<template>
  <!--选择兑换码弹框-->
  <van-popup v-model="popShow" round position="bottom" :style="{ height: height }" class="choose-popup">
    <div class="choose-popup-wrap">
      <div class="popup-header">
        {{ title }}<i class="van-icon van-icon-cross van-action-sheet__close" @click="close"><!----></i>
      </div>
      <div class="base-cell" @click="show = true">
        <div class="base-cell-value">
          <div class="base-cell-body">
            <input
              autofocus="autofocus"
              ref="codeInput"
              type="text"
              placeholder="请输入"
              class="base-field-control"
              v-model="inputValue"
              :maxlength="maxlength"
              @paste="pasting"
            />
            <div class="base-cell-word-limit">
              <span class="base-cell-word-num">{{ inputNum }}</span
              >/{{ maxlength }}
            </div>
          </div>
        </div>
      </div>
      <van-divider />
      <div class="button sticky-bottom btn-blue-no-shadow" @click="submit">保存</div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'singleInputPop',
  props: {
    title: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 5,
    },
    show: {
      type: Boolean,
      default: false,
    },
    isValid: {
      // 是否有校验
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '240px',
    },
    value: {
      type: String,
      default: '',
    },
  },
  created() {
    if (this.value) {
      this.inputValue = this.value
    }
  },
  data() {
    return {
      inputValue: '',
    }
  },
  computed: {
    inputNum: {
      get() {
        return this.inputValue.length || 0
      },
      set() {},
    },
    popShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      },
    },
  },
  watch: {
    popShow(value) {
      this.$nextTick(() => {
        if (value) {
          this.$refs.codeInput.focus()
        }
      })
    },
  },
  methods: {
    // 监听input粘贴事件
    pasting(e){
      e.preventDefault();
      let text;
      let clp = (e.originalEvent || e).clipboardData;
      if (clp === undefined || clp === null) {
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
          text = text.replace(/\s+/g, "");
          if (window.getSelection) {
            let newNode = document.createElement("span");
            newNode.innerHTML = text;
            window.getSelection().getRangeAt(0).insertNode(newNode);
          } else {
            document.selection.createRange().pasteHTML(text);
          }
        }
      } else {
        text = clp.getData('text/plain') || "";
        if (text !== "") {
          text = text.replace(/\s+/g, "");
          document.execCommand('insertText', false, text);
        }
      }
    },
    close() {
      this.inputValue = ''
      this.$emit('update:show', false)
    },
    submit() {
      // 校验
      if (!this.isValid) {
        this.$emit('update:show', false)
      }
      this.$emit('onSubmit', this.inputValue)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-picker__toolbar {
  margin-top: 10px;
}
/deep/ .van-picker__title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 18px;
  margin-left: 25px;
}
/deep/ .van-picker__confirm {
  color: #000000;
}
/deep/ .van-picker__columns {
  margin-top: 30px;
}
/deep/ .van-action-sheet__close{
	padding: 0;
}
.choose-popup {
  width: 100%;
  padding: 0 20px;
  .choose-popup-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: content-box;
  }
  .popup-header {
    padding: 23px 0px 20px 0px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: @darkBlack;
    .van-action-sheet__close {
      top: 23px;
      right: 0;
      padding: 0;
    }
  }
  // 最近出的input 应用在弹框里
  .base-cell {
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    background: #ffffff;
    padding: 0;
    .base-cell-title {
      flex: none;
      box-sizing: border-box;
      margin-right: 16px;
      text-align: left;
      color: @darkBlack;
    }
    .base-cell-value {
      flex: 1;
      position: relative;
      overflow: hidden;
      color: #969799;
      vertical-align: middle;
      word-wrap: break-word;
      .vip-cell-body {
        display: flex;
        text-align: center;
        align-items: center;
      }
      .base-cell-word-limit {
        margin: 20px 0;
        color: @subBlack;
        font-size: 14px;
        text-align: right;
        .base-cell-word-num {
          color: @baseBlue;
        }
      }
    }
    .base-field-control {
      display: block;
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
      color: #323233;
      line-height: inherit;
      text-align: left;
      background-color: transparent;
      border: 0;
      resize: none;
    }
  }
}
</style>
